import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ScienceHook } from './components/ScienceHook';
import { BodyContent } from './components/BodyContent';
import { SolutionTeaser } from './components/SolutionTeaser';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    console.log('[Meta Pixel] Initializing...');
    if ((window as any).fbq) {
      console.log('[Meta Pixel] Already loaded, firing PageView');
      (window as any).fbq('track', 'PageView');
      return;
    }
    const n: any = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments);
      } else {
        n.queue.push(arguments);
      }
    };
    (window as any).fbq = n;
    (window as any)._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => console.log('[Meta Pixel] fbevents.js loaded');
    script.onerror = () => console.error('[Meta Pixel] Failed to load fbevents.js');
    document.head.appendChild(script);
    (window as any).fbq('init', '1664420778222405');
    (window as any).fbq('track', 'PageView');
    console.log('[Meta Pixel] Init and PageView dispatched');
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-gold/30 selection:text-charcoal flex flex-col overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ScienceHook data-id="element-4" />
        <BodyContent data-id="element-5" />
        <SolutionTeaser data-id="element-6" />
        <CTASection data-id="element-7" />
      </main>

      <Footer data-id="element-8" />

      <noscript data-id="element-9">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1664420778222405&ev=PageView&noscript=1" alt="" data-id="element-10" />
      </noscript>
    </div>;
}